import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { EditOutlined, MoreVertOutlined } from "@mui-symbols-material/w300"
import type { CellContext } from "@tanstack/react-table"
import type { FC } from "react"
import { useRef, useState } from "react"

import type { ProductTestResult } from "@/graphql/codegen/graphql"
import { withClose } from "@/utils/withClose"

interface ProductTestResultRowActionsProps {
  row: CellContext<ProductTestResult, unknown>["row"]
  onOverride?: (productTestResult: ProductTestResult) => void
}

const ProductTestResultRowActions: FC<ProductTestResultRowActionsProps> = ({ row, onOverride }) => {
  const anchorElRef = useRef<HTMLButtonElement>(null)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const handleDropdownOpen = () => setIsDropdownOpen(true)
  const handleDropdownClose = () => setIsDropdownOpen(false)

  const handleOverride = withClose(handleDropdownClose)(() => onOverride?.(row.original))

  return (
    <Box className='flex items-center justify-center' ref={anchorElRef}>
      <IconButton onClick={handleDropdownOpen} data-test='expanded-row-actions-button'>
        <MoreVertOutlined />
      </IconButton>
      <Menu
        anchorEl={anchorElRef.current}
        open={isDropdownOpen}
        onClose={handleDropdownClose}
        data-test='expanded-row-actions-menu'
      >
        <MenuItem data-test='override-result-menu-item' onClick={handleOverride}>
          <ListItemIcon>
            <EditOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
          </ListItemIcon>
          <ListItemText primary='Override Result' />
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default ProductTestResultRowActions
